// shared/testConfig.js
/**
 * Test Mode Configuration
 * 
 * Enable test mode with URL parameter: ?testMode=true
 * This provides relaxed timeouts and enables diagnostic logging for development/testing.
 */

export const TEST_MODES = {
    // Production Mode: Aggressive timeouts, no debug logs
    PRODUCTION: {
        name: 'Production (Aggressive)',

        // Timeouts
        IDLE_HINT_DELAY: 5000,        // 5s → Show hint overlay
        IDLE_COUNTDOWN_DELAY: 10000,  // 10s → Start countdown
        IDLE_TIMEOUT_TOTAL: 15000,    // 15s → Disconnect

        // Session
        HEARTBEAT_INTERVAL: 2000,     // 2s between pings

        // Logging
        ENABLE_TANK_DEBUG: false,     // No tank physics logs
        ENABLE_AUDIO_DEBUG: false,    // No audio debug logs

        // New Refinements
        PRESSURE_STRESS_MULTIPLIER: 1.0,
        ENABLE_HOT_BURST_THRESHOLD: 0.05,
    },

    // Testing Mode: Casual timeouts, full debug logs
    TESTING: {
        name: 'Testing (Casual)',

        // Timeouts (4x longer)
        IDLE_HINT_DELAY: 20000,       // 20s → Show hint overlay
        IDLE_COUNTDOWN_DELAY: 40000,  // 40s → Start countdown
        IDLE_TIMEOUT_TOTAL: 60000,    // 60s → Disconnect

        // Session
        HEARTBEAT_INTERVAL: 2000,     // 2s between pings

        // Logging
        ENABLE_TANK_DEBUG: true,      // Tank physics logs every second
        ENABLE_AUDIO_DEBUG: true,     // Audio debug logs

        // New Refinements
        PRESSURE_STRESS_MULTIPLIER: 1.0, // Default 1.0, can be set to 5.0 for stress
        ENABLE_HOT_BURST_THRESHOLD: 0.05,
    },
};

/**
 * Get active test mode from URL
 */
export function getTestMode() {
    if (typeof window === 'undefined') {
        // Server-side: check environment variable
        return process.env.TEST_MODE === 'true' ? TEST_MODES.TESTING : TEST_MODES.PRODUCTION;
    }

    // Client-side: check URL parameter
    const params = new URLSearchParams(window.location.search);
    return params.has('testMode') ? TEST_MODES.TESTING : TEST_MODES.PRODUCTION;
}

/**
 * Get a specific config value for the active mode
 */
export function getTestConfig(key) {
    const mode = getTestMode();
    return mode[key];
}
